import * as React from 'react';

import FirebaseService from '../../Service/FirebaseService';

import './InputBar.css';
import Message from '../MessageView/MessageView';

interface IInputBarState {
    text: string
}

export default class InputBar extends React.Component<any, IInputBarState> {

    constructor(props: any) {
        super(props);

        this.state = {
            text: ''
        }
    }

    private _onChangeHandler(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            text: event.currentTarget.value,
        })
        
    }

    private _onKeyDownHandler(event: React.KeyboardEvent<HTMLInputElement>): void {
        if (event.key == 'Enter') {
            this._sendMessage();
        }
    }

    private _sendMessage = () => {
        if (this.state.text) {
            console.log('sending message');
            FirebaseService.addChatMessage(this.state.text);

            this._clearText();
        }
    }
    
    private _clearText = () => {
        this.setState({
            text: ''
        })
    }

    render() {
        return (
            <div className="inputBar">
                <input 
                    className="inputBar-input"
                    type="text" 
                    value={this.state.text}
                    onChange={(e) => this._onChangeHandler(e)}
                    onKeyPress={(e) => this._onKeyDownHandler(e)}></input>
                <button 
                    className="inputBar-sendButton"
                    onClick={this._sendMessage}>Send</button>
            </div>
        )
    }
}